module.exports = __webpack_public_path__ + "static/media/logo.e52f7cf7.png";